module.exports = __webpack_public_path__ + "lastSlide.webp?65bc7ee3d1b6f4f3708e085acbd85ecf";